import BrandLaunch from 'components/Brand/BrandLaunch/BrandLaunch';

export default BrandLaunch;
